import { render, staticRenderFns } from "./operate.vue?vue&type=template&id=fd031204&scoped=true&"
import script from "./operate.vue?vue&type=script&lang=js&"
export * from "./operate.vue?vue&type=script&lang=js&"
import style0 from "./index.scss?vue&type=style&index=0&id=fd031204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd031204",
  null
  
)

export default component.exports